import React from 'react'
import { Navbar, Footer } from "../../components"
import { ClientSignUp } from "../SignUp"
export default function SignUp() {
  return (
    <div className='emas__signup'>
        <Navbar />
        <ClientSignUp />
        <Footer />
    </div>
  )
}
